import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ShareService } from '@app/shared/services/vault/share.service';
import { stringDateToDatabase, stripHtmlTags, validateUserInput, sanitizePlainTextStrict } from '@app/shared/utils';
import { RootStoreState } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService } from '@app/shared/services';
import { loaderTypes } from '../loader/loader';

import { EditTemplateBasicFormComponent } from '../discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { Router } from '@angular/router';
import { getAllProfessionalRelationShipSortSelector } from '@app/root-store/relationship-store/relationship.selector';

enum VaultType {
  personal = 'personal',
  shared = 'shared',
  entity = 'entity',
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-vault-dialog',
  templateUrl: './add-vault-dialog.component.html',
  // styleUrls: ['./add-vault-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddVaultDialogComponent implements OnInit, OnDestroy {
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  selectedVaultType;
  steps = [];
  stateObject;
  subscription = new Subscription();
  vaultMembers = [];
  vaultAdmins = [];
  vaultSharing = [];
  step = 0;
  w_id = null;
  showSearchConnection = false;
  isTypeSelected = false;

  stepInfo = {
    vault_type: [
      {
        isAnswerSelected: true,
      },
    ],
  };

  selectedVaultTypeInfo = 'vault_type';
  selectedIndex = 0;

  vaultConfigurationList: any = [
    {
      label: 'Personal Vault',
      type: VaultType.personal,
      steps: [{ stepLabel: 'Manage Members', stepType: 'member' }],
      isSelected: false,
    },
    {
      label: 'Entity Vault',
      type: VaultType.entity,
      steps: [
        { stepLabel: 'Add Entity', stepType: 'name' },
        { stepLabel: 'Manage Members', stepType: 'member' },
      ],
      isSelected: false,
    },
  ];
  userObject;
  forms = [];

  formData = [];
  vault_id;
  current_template;
  documentForm;
  securityStateObject;
  vaults = [];
  selectedEntityType;
  routeId;
  entityName;
  allUserConnections = [];
  nonProfessionalUsers = [];
  isShowFooter = false;
  user_type;
  setEntityNameSuggestion = '';
  setEntityTypeSuggestion = '';
  loadOnce = true;
  professionalVaultCreator;
  is_entity_creation_suggestion = false;
  personalVaultCount = 0;
  personalVaults: any[] | undefined;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AddVaultDialogComponent>,
    private store: Store,
    private router: Router,
    private cd: ChangeDetectorRef,
    private vaultShareService: ShareService,
    private store$: Store<RootStoreState.State>,
    private vaultService: SharedVaultService,
    private vaultService$: VaultStoreEffects,
    private documentService: DocumentService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.stateObject = result;
          this.user_type = result.user_type;
          if (this.loadOnce && this.user_type === 'Professional') {
            this.loadOnce = false;
            this.getProfessionalConnections();
            this.cd.detectChanges();
          }
          this.cd.detectChanges();
        } else {
          this.stateObject = null;
        }
      })
    );
    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.vaults = state.vaults;
      })
    );
  }

  selectConnectedUser(event) {
    this.professionalVaultCreator = event;

    this.showSearchConnection = false;
    this.cd.detectChanges();
  }
  ngOnInit(): void {
    if (this.data.isFromPersonalVaults) {
      this.selectVaultType(this.vaultConfigurationList[0]);
    } else if (this.data.isFromEntityVaults) {
      this.selectVaultType(this.vaultConfigurationList[1]);
    }
    const urlParts = this.router.url.split('/');
    const idIndex = urlParts.indexOf('workspace') + 1;
    if (idIndex >= 0 && urlParts[idIndex]) {
      this.w_id = urlParts[idIndex];
    }
    if (this.data.vault_suggestion_details && this.user_type !== 'Professional') {
      this.isTypeSelected = true;
      const item = this.vaultConfigurationList.find((group) => group.type === this.data.vault_suggestion_details.type);
      if (this.data.vault_suggestion_details.type === 'entity') {
        this.is_entity_creation_suggestion = true;
        this.setEntityNameSuggestion = this.data.vault_suggestion_details.name;
        this.setEntityTypeSuggestion = this.data.vault_suggestion_details.new_entity_type;
      }
      this.selectVaultType(item);
      this.addLoginLUser();
    }
    this.subscription.add(
      this.store$.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          if (result) {
            this.userObject = result;
          }
        } catch (ex) {}
      })
    );
    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        const personal_vault = (state?.vaults || []).filter((v: any) => v.type === 'personal');
        this.personalVaultCount = (personal_vault || []).length;
        this.personalVaults = personal_vault;
      })
    );
    if (this.data.vaultType) {
      this.isTypeSelected = true;
      const item = this.vaultConfigurationList.find((group) => group.label === this.data.vaultType);
      this.selectVaultType(item);
    }
  }

  getProfessionalConnections() {
    this.subscription.add(
      this.store.select(getAllProfessionalRelationShipSortSelector()).subscribe((data) => {
        this.allUserConnections = data.filter((x) => x.connection_status == 'approved');
        if (this.user_type === 'Professional') {
          this.allUserConnections = [this.stateObject, ...data.filter((x) => x.connection_status == 'approved')];
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  selectVaultType(item) {
    this.vaultConfigurationList.forEach((opt) => {
      opt.isSelected = false;
    });
    item['isSelected'] = !item.isSelected;
    this.selectedVaultType = item.type;

    this.steps = item.steps;
    this.isTypeSelected = true;
    this.vaultMembers = [];
    this.addLoginLUser();
    this.cd.detectChanges();
  }

  changeStep(step) {
    if (this.is_entity_creation_suggestion) {
      this.createVault();
    } else {
      if (step === 1) {
        if (this.steps && this.steps.length && this.steps[this.step + 1] && this.selectedVaultType == 'entity') {
          this.step = this.step + 1;
          this.cd.detectChanges();
        } else {
          this.createVault();
        }
      } else {
        this.step = this.step - 1;
        this.cd.detectChanges();
      }
    }
  }

  setVaultMember(members) {
    this.vaultMembers = members;
  }

  setVaultAdmins(admins) {
    this.vaultAdmins = admins;
  }

  setVaultSharing(sharing) {
    this.vaultSharing = sharing;
  }

  setEntityType(entityType) {
    this.selectedEntityType = entityType;
  }

  setEntityName(name) {
    // Strip HTML tags to prevent HTML injection in vault/entity names
    this.entityName = stripHtmlTags(name || '').trim();
  }

  private getSanitizedEntityName(): string {
    const raw = (this.entityName || '').trim();
    const validation = sanitizePlainTextStrict(raw);
    if (!validation.isValid) {
      return '';
    }
    return validation.sanitized;
  }

  formatVaultName(users) {
    const names = users.map((user) => user?.user_first_name || user?.first_name);
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(' & ');

    // For more than 2 names, join with a comma, except for the last one
    return `${names.slice(0, -1).join(', ')}, & ${names[names.length - 1]}`;
  }

  addLoginLUser() {
    if (this.user_type === 'Professional' && this.professionalVaultCreator?.id !== this.stateObject.id) {
      this.vaultMembers.push({
        id: this.stateObject.id,
        user_id: this.stateObject.id,
        relationship_name: 'Client',
        user_first_name: this.stateObject.first_name,
        memberUser: {
          id: this.stateObject.id,
          user_id: this.stateObject.id,
          name: this.stateObject.first_name + ' ' + this.stateObject.last_name,
          relationship_name: 'Client',
          user_profile_image_url: this.stateObject.profile_image_url,
          key: 'users',
          user_first_name: this.stateObject.first_name,
          user_last_name: this.stateObject.last_name,
          last_name: this.stateObject.last_name,
          profile_image_url: this.stateObject.profile_image_url,
        },
      });
    }
  }
  createVault() {
    let vaultMembers = [];
    if (this.user_type === 'Professional') {
      vaultMembers = [...this.vaultMembers];
      if (this.professionalVaultCreator.id === this.stateObject.id) {
        vaultMembers.unshift({
          user_id: this.professionalVaultCreator.id,
          user_profile_image_url: this.professionalVaultCreator.profile_image_url,
          name: this.professionalVaultCreator.first_name + ' ' + this.professionalVaultCreator.last_name,
          user_first_name: this.professionalVaultCreator.first_name,
          type: 'owner',
          is_limited: false,
          isSelected: true,
        });
      } else {
        vaultMembers.unshift({
          user_id: this.professionalVaultCreator.user_id,
          user_profile_image_url: this.professionalVaultCreator.user_profile_image_url,
          name: this.professionalVaultCreator.user_first_name + ' ' + this.professionalVaultCreator.user_last_name,
          user_first_name: this.professionalVaultCreator.user_first_name,
          type: 'owner',
          is_limited: false,
          isSelected: true,
        });
      }
    } else {
      vaultMembers = [...this.vaultMembers];
      vaultMembers.unshift({
        user_email: this.userObject?.email,
        user_id: this.userObject?.id,
        user_profile_image_url: this.userObject?.profile_image_url,
        name: this.userObject?.name,
        user_first_name: this.userObject?.first_name,
        type: 'owner',
        is_limited: false,
        isSelected: true,
      });
    }
    // Get raw name and validate against HTML/script
    const rawVaultName =
      this.selectedVaultType === VaultType.entity ? this.getSanitizedEntityName() : this.formatVaultName(vaultMembers);
    const validation = sanitizePlainTextStrict(rawVaultName || '');
    if (!validation.isValid) {
      return;
    }
    // Final sanitize to strip any HTML/script injection attempts
    let vaultName = stripHtmlTags(validation.sanitized || '').trim();
    if (this.selectedVaultType === VaultType.personal) {
      const allVaultNames = this.personalVaults.map((v) => v.name);
      vaultName = this.generateUniqueVaultName(vaultName, allVaultNames);
    }
    let payload;
    if (this.data?.vault_suggestion_details?.name) {
      vaultName = stripHtmlTags(this.data.vault_suggestion_details.name || '').trim();
    }
    // If after sanitization vaultName is empty, block creation
    if (!vaultName) {
      return;
    }
    if (this.w_id != null) {
      payload = {
        name: vaultName ?? 'Untitled Vault',
        type: this.selectedVaultType,
        user_id: this.professionalVaultCreator ? this.professionalVaultCreator.id : this.userObject?.id,
        member: vaultMembers.map(({ user_id, type, is_limited }) => ({ user_id, type, ...(is_limited !== undefined && { is_limited }) })),
        ...(this.vaultAdmins.length && { admin: this.vaultAdmins.map(({ user_id, type }) => ({ user_id, type })) }),
        workspace_id: this.w_id,
      };
    } else {
      payload = {
        name: vaultName ?? 'Untitled Vault',
        type: this.selectedVaultType,
        user_id: this.professionalVaultCreator ? this.professionalVaultCreator.id : this.userObject?.id,
        member: vaultMembers.map(({ user_id, type, is_limited }) => ({ user_id, type, ...(is_limited !== undefined && { is_limited }) })),
        ...(this.vaultAdmins.length && { admin: this.vaultAdmins.map(({ user_id, type }) => ({ user_id, type })) }),
      };
    }

    this.subscription.add(
      this.vaultService.createVault(payload).subscribe(
        async (data) => {
          if (data) {
            const promises = [];
            for (let index = 0; index < this.vaultSharing.length; index++) {
              const element = this.vaultSharing[index];
              promises.push(this.createShared(element, element.newShareTypeDetails, data.id));
            }
            try {
              await Promise.all(promises);
            } catch (error) {
              console.error('🚀 ~ AddVaultDialogComponent ~ error:', error);
            }
            if (this.selectedVaultType === VaultType.entity) {
              await this.createEntityTemplate(data);
            }
            if (!this.data.fromDiscovery) this.dialogRef.close({ message: 'dispatch vault', data: data });
            if (this.data.fromDiscovery) this.dialogRef.close({ vault_id: data.id, data: data });
          }
        },
        (error: any) => {}
      )
    );
  }

  createShared(selectedUser, newShareTypeDetails, vault_id) {
    return new Promise((resolve) => {
      if (!newShareTypeDetails) {
        //if no options have been selected set defaults
        newShareTypeDetails = { share_date: new Date(Date.now()).toLocaleDateString(), is_sealed: false };
      }

      let obj = {
        connection_status: selectedUser.connection_status,
        is_sealed: newShareTypeDetails.is_sealed,
        is_editable: newShareTypeDetails.is_editable,
        share_date: newShareTypeDetails.share_date ? stringDateToDatabase(newShareTypeDetails.share_date) : null,
        end_date: newShareTypeDetails.end_date ? stringDateToDatabase(newShareTypeDetails.end_date) : null,
        shared_with_user_id: selectedUser.id,
        user_id: this.userObject.id,
        vault_id: vault_id ? vault_id : null,
      };
      if (obj['vault_id'] == null) {
        delete obj['vault_id'];
      }
      this.subscription.add(
        this.vaultShareService.createVaultShareInformation(obj).subscribe(async (results) => {
          //refresh modal
          resolve(null);
        })
      );
    });
  }

  createformIdForFirstUploadDocument(argument, isShowLoader = true) {
    return new Promise((resolve, reject) => {
      let data = {
        user_id: this.userObject.id,
        vault_form_id: argument.vaultFormId,
        vaultId: argument.vaultId,
        url: 'my-vault/0',
      };
      this.subscription.add(
        this.documentService.getforIdForFirstUploadDocument(data, isShowLoader ? loaderTypes.mainAnimation : loaderTypes.none).subscribe(
          (res) => {
            try {
              this.vault_id = res['vault_user_form_id'].vault_id;
              this.securityStateObject = res['vault_user_form_id'].public_key;
            } catch (error) {}
            if (res.vault_user_form_id.vault_user_form_id) {
              resolve({ vault_form_id: argument.vaultFormId, hub_vault_user_form_id: res.vault_user_form_id.vault_user_form_id, argument });
            }
          },
          (error) => {}
        )
      );
    });
  }

  initFormData(vaultFormId, form_name = '') {
    this.current_template = this.forms.find((x) => x.id == vaultFormId);
    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: [this.getSanitizedEntityName(), Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    this.formData = this.current_template.template;
    this.cd.detectChanges();
  }

  updateFormTemplateData(vault_user_form_id, isShowLoader = true) {
    return new Promise(async (resolve, reject) => {
      const payload = {
        id: vault_user_form_id,
        status_progress: 'need to add',
        user_id: this.userObject.id,
        form_data: {
          beneFicaryForm: [],
          dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
          showNotes: undefined,
        },
        user_pk: this.securityStateObject.public_key,
      };
      this.subscription.add(
        this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined, isShowLoader).subscribe(
          (res) => {
            resolve(res);
          },
          (error) => {}
        )
      );
    });
  }

  formName(hub_vault_user_form_id) {
    return new Promise((resolve) => {
      this.documentForm.controls.dynamicFieldsForm.value[0].foreignDisregardedEntityFullLegalNameofEntity =
        this.getSanitizedEntityName();
      this.subscription.add(
        this.documentService
          .saveNameWithAction(
            {
              form_name: this.getSanitizedEntityName(),
              id: hub_vault_user_form_id,
              naming_convention: this.current_template.naming_convention,
              dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
              user_id: this.userObject.id,
              current_template: this.current_template,
              filterArrayItems: this.editTemplateBasicForm.filterArrayItems,
              vault_id: this.vault_id,
              vault_list: this.vaults,
            },
            true
          )
          .subscribe(
            (res) => {
              resolve(res);
            },
            (error) => {}
          )
      );
    });
  }

  async createEntityTemplate(data) {
    const formData: any = await this.createformIdForFirstUploadDocument({
      vaultFormId: this.selectedEntityType?.id,
      title: this.selectedEntityType.template,
      vaultType: this.selectedEntityType.template,
      hub_vault_user_form_id: null,
      origin: 'onboarding',
      vaultId: data.id,
    });
    this.formData = [];
    this.cd.detectChanges();
    this.initFormData(formData.vault_form_id);
    const updateRes: any = await this.updateFormTemplateData(formData.hub_vault_user_form_id);
    await this.formName(formData.hub_vault_user_form_id);
  }
  generateUniqueVaultName(baseName: string, existingVaultNames: string[]): string {
    // get names that start with the same base name
    const matching = existingVaultNames.filter((name) => name === baseName || name.startsWith(baseName + ' '));

    if (matching.length === 0) {
      return baseName;
    }

    // extract numeric suffixes
    const counts = matching.map((name) => {
      const parts = name.replace(baseName, '').trim(); // get suffix e.g. "2"
      const num = parseInt(parts);
      return isNaN(num) ? 1 : num;
    });

    const max = Math.max(...counts);
    return `${baseName} ${max + 1}`;
  }
}
